import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

export function NotFoundPage() {
  const [countdown, setCountdown] = useState(5);

  useEffect(() => {
    // Countdown timer
    const timer = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          clearInterval(timer);
          // Perform a redirect to homepage
          window.location.replace('/');
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  return (
    <div className="flex items-start justify-center min-h-screen bg-gray-50 pt-16">
      <div className="text-center max-w-md mx-auto p-8 bg-white rounded-lg shadow-lg">
        <h1 className="text-3xl font-bold mb-4 text-gray-800">Strona nie została znaleziona</h1>
        <p className="text-gray-600 mb-2">
          Ta strona nie istnieje lub została przeniesiona.
        </p>
        <p className="text-lg font-semibold text-red-600 mb-6">
          Przekierowanie za {countdown} sekund{countdown !== 1 ? 'y' : ''}...
        </p>
        <div className="space-y-3">
          <Link
            to="/"
            className="inline-block bg-red-600 hover:bg-red-700 text-white font-medium py-3 px-6 rounded-lg transition-colors duration-200"
          >
            Przejdź do strony głównej
          </Link>
          <p className="text-sm text-gray-500">
            Jeśli przekierowanie nie działa, kliknij powyższy przycisk
          </p>
        </div>
      </div>
    </div>
  );
}

